<template>
  <div>
    <challenge-list v-show="tabType === 1" @handleShow="handleShow" />
    <challenge-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow" />
    <challenge-stage-list v-if="tabType === 3" :rowItem="rowItem" @handleShow="handleShow" />
  </div>
</template>

<script>
import challengeList from './list.vue'
import challengeShow from './show.vue'
import challengeStageList from './stageList.vue'
export default {
  components: { challengeList, challengeShow,challengeStageList },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>